define("calendar/components/calendar/scheduled-stories", ["exports", "@ember/component", "@ember/object", "@ember/object/computed", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "moment", "later/utils/time-format", "@ember/template-factory"], function (_exports, _component, _object, _computed, _service, _utils, _component2, _tracking, _moment, _timeFormat, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"moment",0,"later/utils/time-format",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="cCA--stories"
    {{did-insert this.fetchStoryCounts}}
    {{did-update this.fetchStoryCounts @timelineStories @targetDate}}
    {{on "click" this.viewStoriesCalendar}}
  >
    {{#if this.dailyStoriesCounts.length}}
      {{#each this.dailyStoriesCounts as |dayStoryCount|}}
        {{#if (are-equal dayStoryCount 0)}}
          <div class="cCA--stories__item u--text--white">
            {{t "stories.scheduled_count.no_stories"}}
          </div>
        {{else if (are-equal dayStoryCount 1)}}
          <div class="cCA--stories__item">
            {{t "stories.scheduled_count.one_story"}}
          </div>
        {{else}}
          <div class="cCA--stories__item">
            {{t "stories.scheduled_count.number_stories" storyCount=dayStoryCount}}
          </div>
        {{/if}}
      {{/each}}
    {{else}}
      <div class="cCA--stories__item">
        {{t "stories.scheduled_count.none_scheduled"}}
      </div>
    {{/if}}
    <span class="cCA--stories__hint">
      {{t "stories.scheduled_count.click_stories_tab"}}
    </span>
  </div>
  */
  {
    "id": "OCWg2mCe",
    "block": "[[[11,0],[24,0,\"cCA--stories\"],[4,[38,0],[[30,0,[\"fetchStoryCounts\"]]],null],[4,[38,1],[[30,0,[\"fetchStoryCounts\"]],[30,1],[30,2]],null],[4,[38,2],[\"click\",[30,0,[\"viewStoriesCalendar\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"dailyStoriesCounts\",\"length\"]],[[[42,[28,[37,5],[[28,[37,5],[[30,0,[\"dailyStoriesCounts\"]]],null]],null],null,[[[41,[28,[37,6],[[30,3],0],null],[[[1,\"        \"],[10,0],[14,0,\"cCA--stories__item u--text--white\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"stories.scheduled_count.no_stories\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,6],[[30,3],1],null],[[[1,\"        \"],[10,0],[14,0,\"cCA--stories__item\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"stories.scheduled_count.one_story\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"cCA--stories__item\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"stories.scheduled_count.number_stories\"],[[\"storyCount\"],[[30,3]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]],[]]]],[3]],null]],[]],[[[1,\"    \"],[10,0],[14,0,\"cCA--stories__item\"],[12],[1,\"\\n      \"],[1,[28,[35,7],[\"stories.scheduled_count.none_scheduled\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[10,1],[14,0,\"cCA--stories__hint\"],[12],[1,\"\\n    \"],[1,[28,[35,7],[\"stories.scheduled_count.click_stories_tab\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@timelineStories\",\"@targetDate\",\"dayStoryCount\"],false,[\"did-insert\",\"did-update\",\"on\",\"if\",\"each\",\"-track-array\",\"are-equal\",\"t\"]]",
    "moduleName": "calendar/components/calendar/scheduled-stories.hbs",
    "isStrictMode": false
  });
  let ScheduledStoriesComponent = _exports.default = (_dec = (0, _service.inject)('calendar/config'), _dec2 = (0, _computed.readOnly)('calendarConfig.fullCalendar'), _dec3 = (0, _computed.readOnly)('userConfig.currentTimeZone.identifier'), (_class = class ScheduledStoriesComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "router", _descriptor, this);
      _initializerDefineProperty(this, "calendarConfig", _descriptor2, this);
      _initializerDefineProperty(this, "userConfig", _descriptor3, this);
      _initializerDefineProperty(this, "dailyStoriesCounts", _descriptor4, this);
      _initializerDefineProperty(this, "fullCalendar", _descriptor5, this);
      _initializerDefineProperty(this, "timeZoneIdentifier", _descriptor6, this);
    }
    get currentTimeZoneIdentifier() {
      return (0, _utils.isEmpty)(this.timeZoneIdentifier) ? _moment.default.tz.guess() : this.timeZoneIdentifier;
    }
    async fetchStoryCounts() {
      if (this.fullCalendar) {
        const dailyStoriesCounts = [];
        const startTime = (0, _moment.default)(this.fullCalendar?.view.activeStart);

        // For each day of the week
        for (let i = 0; i < 7; i++) {
          const unixStartTime = startTime.unix();
          const unixEndTime = unixStartTime + _timeFormat.convert.day().toSeconds();
          const dayStoryCount = this.args.timelineStories.filter(story => {
            const storyUnixStartTime = story.startTime ? (0, _moment.default)(story.startTime).unix() : (0, _moment.default)().unix();
            return storyUnixStartTime >= unixStartTime && storyUnixStartTime < unixEndTime;
          }).length;
          dailyStoriesCounts.push(dayStoryCount);
          startTime.add(1, 'day');
        }
        if (dailyStoriesCounts.every(count => count === 0)) {
          this.dailyStoriesCounts = [];
        } else {
          this.dailyStoriesCounts = dailyStoriesCounts;
        }
      }
    }
    viewStoriesCalendar() {
      this.router.transitionTo('cluster.schedule.stories');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "calendarConfig", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dailyStoriesCounts", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "fullCalendar", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "timeZoneIdentifier", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "fetchStoryCounts", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "fetchStoryCounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "viewStoriesCalendar", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "viewStoriesCalendar"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ScheduledStoriesComponent);
});